module.exports = __webpack_public_path__ + "img/taylorBellCastingHall201027-224.035a0bb7.jpg";